// extracted by mini-css-extract-plugin
module.exports = {"disneyButton":"mQT3Cm"};